<template>
  <div
    class="account"
    data-test="page-account"
  >
    <el-menu
      :router="true"
      :default-active="defaultActive"
      mode="horizontal"
    >
      <el-menu-item
        :class="currentStep == 'info' ? 'is-active': ''"
        index="1"
        route="/account/info"
      >
        <span
          class="menu-text"
          data-test="option-account"
        >My Info</span>
      </el-menu-item>
      <el-menu-item
        :class="currentStep == 'subscription' ? 'is-active': ''"
        index="2"
        route="/account/subscription"
      >
        <span
          class="menu-text"
          data-test="option-account"
        >My Subscription</span>
      </el-menu-item>
      <el-menu-item
        :class="currentStep == 'feedback' ? 'is-active': ''"
        index="3"
        route="/account/feedback"
      >
        <span
          class="menu-text"
          data-test="option-account"
        >Feedback</span>
      </el-menu-item>
    </el-menu>
    <div>
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      defaultActive: '/account/info',
      currentStep: 'info',
    };
  },
  beforeMount() {
    window.eventBus.$on('settings-tab-change', (step) => {
      this.currentStep = step;
    });
  },
};
</script>
<style lang="scss">
@import "../assets/scss/variables.scss";

.account {
  width: 75%;
  margin: 0 auto;

  .el-menu {
    margin-top: 36px;
    border-bottom: 0px;
    .el-menu-item {
      height: auto !important;
      width: 33%;
      text-align: center;
      padding-top: 0px !important;
      padding-bottom: 16px !important;
      font-size: 20px;
      font-weight: bold;
      line-height: 24px !important;
      color: $light-gray;
      .el-form-item__label {
        line-height: 0 !important;
      }
    }
    .is-active {
      border-bottom: 2px solid $blue !important;
      font-weight: bold;
      color: $blue;

      span {
        color: $blue !important;
      }
    }
  }
}
// @media (max-width: 1024px) {
//   .account{
//     max-width: 504px;
//     .el-menu{
//       max-width: 504px;
//     }
//   }
// }
@media (max-width: 768px) {
  .account {
   width: 90%;
  }
}
@media (max-width: 576px) {
  .account {
    width: 100%;
    .el-menu {
      margin-top: 36px;
      display: flex;
      justify-content: space-around;
      .el-menu-item {
        font-size: 14px;
        padding: 10px 0px !important;
        width: 33%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/src/pages/Account.vue